function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.32662 0H0V22.6935H23.315V18.0616H5.32662V0Z",
  fill: "currentColor"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M31.8485 0H26.5219V22.6935H31.8485V0Z",
  fill: "currentColor"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M50.6351 0H50.3678C45.2932 0 40.8219 1.55762 38.0498 4.29276C37.0633 5.25707 36.2892 6.408 35.7751 7.67486C35.261 8.94172 35.0176 10.2978 35.06 11.6597C35.06 17.9722 40.1842 22.4662 48.1341 23.2114V25.7826C48.1117 26.2492 48.1895 26.7152 48.3624 27.1507C48.5353 27.5863 48.7996 27.9818 49.1382 28.3119C49.4768 28.642 49.8823 28.8995 50.3288 29.0677C50.7753 29.236 51.2529 29.3114 51.731 29.2891H61.3304V24.9442H54.0411C53.2774 24.9442 53.14 24.7951 53.14 24.0648V23.1779C61.0707 22.332 65.9888 17.9275 65.9888 11.656C66.0316 10.2931 65.7882 8.93606 65.2733 7.66844C64.7585 6.40082 63.9832 5.24947 62.9952 4.2853C60.2383 1.56507 55.7326 0 50.6351 0ZM50.2189 4.63185H50.8604C56.6872 4.63185 60.6011 7.45643 60.6011 11.6597C60.6011 15.8631 56.6872 18.6876 50.8604 18.6876H50.2189C45.3581 18.6876 40.4477 16.5115 40.4477 11.6597C40.4477 7.45643 44.3959 4.63185 50.2189 4.63185Z",
  fill: "currentColor"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M88.5405 12.0995C88.5405 16.2618 86.2915 18.3746 81.8545 18.3746H81.2092C76.7723 18.3746 74.5233 16.2618 74.5233 12.0995V0H69.2005V12.4125C69.2005 19.146 73.6947 23.0065 81.5338 23.0065C89.2545 23.0065 93.8633 19.0454 93.8633 12.4125V0H88.5405V12.0995Z",
  fill: "currentColor"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M102.397 0H97.07V22.6935H102.397V0Z",
  fill: "currentColor"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M119.991 0H105.604V22.6935H119.991C128.048 22.6935 133.256 18.2405 133.256 11.3467C133.256 4.45299 128.048 0 119.991 0ZM110.93 4.63186H119.254C124.886 4.63186 127.865 6.95337 127.865 11.3393C127.865 15.7252 124.886 18.0467 119.254 18.0467H110.93V4.63186Z",
  fill: "currentColor"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M141.79 0H136.463V22.6935H141.79V0Z",
  fill: "currentColor"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M193.073 0L185.761 8.26877L178.518 0H144.996V4.63558H155.695V22.6935H161.022V4.63558H171.717V0.327919L183.066 12.9602V22.6935H188.392V12.9602L200 0H193.073Z",
  fill: "currentColor"
});
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 30,
    viewBox: "0 0 200 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.64407a9f.svg";
export { ForwardRef as ReactComponent };